// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"qz_a vh_g"};